function initGalleryProgress() {
  var sliders = document.querySelectorAll('.product__media-wrapper .slider, .product__media-wrapper [id^="Slider-"]');
  sliders.forEach(function (slider) {
    var wrapper = slider.closest('.product__media-wrapper');
    if (!wrapper) return;

    function update() {
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      var progress = maxScroll > 0 ? (slider.scrollLeft / maxScroll) * 100 : 0;
      progress = Math.max(8, Math.min(100, progress));
      wrapper.style.setProperty('--gallery-progress', progress + '%');
    }

    slider.addEventListener('scroll', update, { passive: true });
    update();
  });
}

document.addEventListener('DOMContentLoaded', initGalleryProgress);
document.addEventListener('shopify:section:load', initGalleryProgress);